module.exports = __webpack_public_path__ + "static/media/IMG_1561.b9cb5e45.JPG";